import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import '@ifeng-fe/ui_pc_lazyLoad/src/core/intersection-observer';
import SsrIntersectionObserver from '@ifeng-fe/ui_pc_lazyLoad/src/core/ssrIntersectionObserver';
const RealIntersectionObserver = typeof IntersectionObserver !== 'undefined' ? IntersectionObserver : SsrIntersectionObserver;

class Text extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
        handleMouseUp: PropTypes.func,
    };

    ref = React.createRef();

    createMarkup = () => {
        const { content } = this.props;

        return { __html: content };
    };

    componentDidMount() {
        if (!window.__IFENG_LOW__) {
            const observer = new RealIntersectionObserver((changes) => {
                changes
                    .filter((item) => item.intersectionRatio > 0)
                    .forEach((change) => {
                        const container = change.target;

                        container.onload = () => {
                            if (container.classList && container.classList.remove) {
                                container.classList.remove('empty_bg');
                            }

                            container.style.width = '';
                            container.style.height = '';
                        };

                        container.onerror = () => {
                            container.style.opacity = '';
                        };

                        container.src = container.getAttribute('data-lazyload');

                        observer.unobserve(container);
                    });
            });

            Array.from(this.ref.current.getElementsByTagName('img'))
                .filter((item) => {
                    return !!item.getAttribute('data-lazyload');
                })
                .forEach((item) => {
                    observer.observe(item);
                });
        } else {
            Array.from(this.ref.current.getElementsByTagName('img'))
                .filter((item) => {
                    return !!item.getAttribute('data-lazyload');
                })
                .forEach((item) => {
                    const container = item;

                    container.onload = () => {
                        if (container.classList && container.classList.remove) {
                            container.classList.remove('empty_bg');
                        }

                        container.style.width = '';
                        container.style.height = '';
                    };

                    container.onerror = () => {
                        container.style.opacity = '';
                    };

                    container.src = container.getAttribute('data-lazyload');
                });
        }
    }

    render() {
        const { handleMouseUp } = this.props;

        return <div className={styles.text} dangerouslySetInnerHTML={this.createMarkup()} onMouseUp={handleMouseUp} ref={this.ref} />;
    }
}

export default Text;
